"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineX } from "react-icons/hi";
import { getFileIcon } from "@/app/[tenant]/(console)/comms/chat/window/helpers";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
import { useChatConfigContext, useChatInputContext } from "./chat-context";
export function ChatFileAttachments() {
  const $ = _c(11);
  const {
    size
  } = useChatConfigContext();
  const {
    selectedFiles,
    removeFile,
    setPreviewFile
  } = useChatInputContext();
  if (selectedFiles.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== removeFile || $[1] !== selectedFiles || $[2] !== setPreviewFile || $[3] !== size) {
    let t1;
    if ($[5] !== removeFile || $[6] !== setPreviewFile || $[7] !== size) {
      t1 = (file, index) => <div key={`${file.name}-${file.lastModified}`} className={cx("relative mb-2 ml-1 flex items-center gap-2 rounded-xl px-1.5 py-1 text-primary-800 shadow-md", "cursor-pointer", "bg-background/80 backdrop-blur-sm", size === "sm" ? "max-w-44" : "max-w-sm")} onClick={() => setPreviewFile(file)}>{getFileIcon(file)}<span className="truncate text-body">{file.name}</span><Button variant="ghost" onClick={e => {
          e.stopPropagation();
          removeFile(index);
        }} className="!p-0 *:text-primary" icon={<HiOutlineX size={16} />} /></div>;
      $[5] = removeFile;
      $[6] = setPreviewFile;
      $[7] = size;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    t0 = selectedFiles.map(t1);
    $[0] = removeFile;
    $[1] = selectedFiles;
    $[2] = setPreviewFile;
    $[3] = size;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[9] !== t0) {
    t1 = <div className="justify-left flex flex-wrap">{t0}</div>;
    $[9] = t0;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}